import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinner,
  faAngleRight,
  faAngleLeft,
  faEllipsis,
  faKey,
} from "@fortawesome/free-solid-svg-icons";
import { listUsers } from "../../../store/reducer/user/userSlice";
import { getUserScreens, updateUserScreens } from "../../../store/reducer/screen/screenSlice";
import { getDdOptionForUI } from "../../../store/reducer/ddOption/ddOptionSlice";
import { debounce } from "lodash";

function ListUser() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const {
    loading,
    users = [],
    totalCount,
  } = useSelector((state) => state.usersList);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [accesses, setAccesses] = useState([]);
  const [accessLoading, setAccessLoading] = useState(false);

  const { options = [] } = useSelector((state) => state.ddOptions);

  useEffect(() => {
    dispatch(getDdOptionForUI());
    dispatch(listUsers({ search, page, limit }));
  }, []);

  const handleSearch = (search = "") => {
    dispatch(listUsers({ search, page, limit }));
  };
  const debouncedSearch = useCallback(debounce(handleSearch, 800), [users]);

  const handlePageClick = ({ selected }) => {
    const page = selected + 1;
    setPage(page);
    dispatch(listUsers({ search, page, limit }));
  };

  const openModal = async (user) => {
    setSelectedUser(user);
    setAccessLoading(true);
    const res = await dispatch(getUserScreens(user.id));
    setAccesses(res.payload || []);
    setAccessLoading(false);
    setModalOpen(true);
  };

  const toggleAccess = (screenId) => {
    setAccesses((prev) =>
      prev.includes(screenId)
        ? prev.filter((id) => id !== screenId)
        : [...prev, screenId]
    );
  };

  const saveAccess = async () => {
    await dispatch(
      updateUserScreens({ userId: selectedUser.id, screens: accesses })
    );
    setModalOpen(false);
  };
  const screenOptions = options
      .filter(
        (option) =>
          option.ui_name === "Screens" && option.field_name === "Screen"
      )
      .sort((a, b) => a.sort_field - b.sort_field);

  // Check if every screen in the list is currently inside the 'accesses' array
  const isAllSelected =
    screenOptions.length > 0 &&
    screenOptions.every((screen) => accesses.includes(screen.id));

  const handleSelectAll = () => {
    if (isAllSelected) {
      // If all selected, clear them (Deselect All)
      setAccesses([]);
    } else {
      // Otherwise, add all IDs to the state
      const allIds = screenOptions.map((s) => s.id);
      setAccesses(allIds);
    }
  };
  return (
    <>
      <div className="block md:flex justify-between mb-[30px]">
        <div className="flex gap-[16px] items-center mb-[40px] md:mb-0">
          <Link to="/setting">
            <div className="bg-[#F8F8F8] rounded-[10px] p-[8px]">
              <img
                className="w-[24px]"
                src={process.env.PUBLIC_URL + "/icons/back.png"}
                alt="back icon"
              />
            </div>
          </Link>
          <div className="flex flex-col">
            <span className="font-Inter font-[400] leading-[16px] text-[#9E9E9E] text-[14px]">
              User / List User
            </span>
            <span className="font-Inter font-[700] leading-[30px] text-[24px]">
              List User
            </span>
          </div>
        </div>
        <div className="">
          <Link to="/setting/user/add">
            <div className="py-[10px] px-[40px] bg-[#F8F8F8] font-[500] font-Inter text-[18px] flex justify-center text-[#17171B] rounded-[12px] border-2 border-[#17171B] w-max">
              <span>Add User</span>
            </div>
          </Link>
        </div>
      </div>

      <div className="flex flex-col mt-[20px] gap-[40px]">
        <div className="">
          <div className="md:p-5 bg-[#F8F8F8] mt-[20px] rounded-l-[12px]">
            <div className="flex flex-col">
              <div className="md:flex justify-between items-center p-[12px]">
                <div className="leading-[30px] font-Mulish font-[700] text-[24px] mb-[8px] md:mb-0">
                  <span className="">Users Data</span>
                </div>
                <div className="relative">
                  <input
                    className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-4 pl-[60px] rounded-[12px] leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    id="search"
                    name="search"
                    onChange={(e) => {
                      setSearch(e.target.value);
                      debouncedSearch(e.target.value);
                    }}
                  />
                  <div className="pointer-events-none absolute inset-y-0 flex items-center px-5 text-gray-700">
                    <img
                      src={process.env.PUBLIC_URL + "/icons/search.png"}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="sm:rounded-lg mt-5 overflow-scroll">
                <table className="w-full text-center">
                  <thead className="bg-white">
                    <tr className="rounded-[12px]">
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Id
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Role
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Bank Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Business Mileage Rate
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Personal Mileage Rate
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Hour Rate
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Company Car
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Company Car Registration
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 font-[Inter] font-[600] text-[14px] text-[#6D6D6F] leading-[20px] tracking-wider text-nowrap"
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinner} size="xl" spin />
                  ) : (
                    <tbody>
                      {users.map((user) => (
                        <tr key={user.id} className="text-center">
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F] font-[600]">
                            {user.id}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.firstname} {user.lastname}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.email}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.role}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.bankname || 'NA'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {Number(user?.mileageRate)?.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {Number(user?.personalMileageRate)?.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {Number(user?.hourRate)?.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.companyCar ? "Yes" : "No"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            {user.companyCar ? user.companyCarRegistration : "NA"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-[14px] text-[#6D6D6F]">
                            <span
                              className={`p-1 inline-flex text-xs leading-5 font-semibold rounded-lg ${
                                user.status == "Active"
                                  ? `bg-green-200 text-green-800`
                                  : `bg-red-200 text-red-800`
                              } `}
                            >
                              {user.status}
                            </span>
                          </td>
                          <td className="px-3 py-2 whitespace-nowrap font-medium">
                            <div className="flex gap-[10px] justify-center">
                              <div>
                                <Link
                                  to={`/setting/user/${user.id}`}
                                  className={
                                    user.id ===
                                    JSON.parse(
                                      localStorage.getItem("userSession")
                                    ).id
                                      ? "pointer-events-none bg-gray"
                                      : ""
                                  }
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL + "/icons/edit.png"
                                    }
                                    alt=""
                                    className="w-[40px] bg-teal-100 rounded-lg"
                                  />
                                </Link>
                              </div>
                              <div
                                onClick={() => openModal(user)}
                                className="cursor-pointer"
                              >
                                <FontAwesomeIcon icon={faKey} size="l" className="w-[40px] mt-[10px] rounded-lg"/>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center mt-[20px] gap-[40px] md:p-5 bg-[#F8F8F8] rounded-l-[12px]">
        <div className="hidden md:block font-Inter font-[300] text-nowrap">
          <span>
            Showing <b>{page}</b> of <b>{Math.ceil(totalCount / limit)}</b>{" "}
            pages
          </span>
        </div>
        <div className="w-full flex justify-end">
          <ReactPaginate
            className="react_pagination_ul"
            breakLabel={
              <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                <FontAwesomeIcon icon={faEllipsis} size="xl" />
              </span>
            }
            nextLabel={
              <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md">
                <FontAwesomeIcon icon={faAngleRight} size="xl" />
              </span>
            }
            onPageChange={handlePageClick}
            pageCount={Math.ceil(totalCount / limit)}
            previousLabel={
              <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                <FontAwesomeIcon icon={faAngleLeft} size="xl" />
              </span>
            }
            activeClassName="bg-black text-white"
            pageClassName="block hover:bg-black hover:text-white rounded-md  mr-4"
            pageLinkClassName="w-10 h-10 flex justify-center items-center"
            containerClassName="flex items-center justify-center"
          />
        </div>
      </div>

      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity"
          onClick={() => setModalOpen(false)}
        >
          {/* Modal Container */}
          <div
            className="relative w-full max-w-md transform overflow-hidden rounded-xl bg-white shadow-2xl transition-all m-4"
            onClick={(e) => e.stopPropagation()}
          >
            
            {/* 1. Header (Fixed) */}
            <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
              <h2 className="font-inter text-lg font-bold text-gray-900">
                Manage Access
                <span className="block text-sm font-normal text-gray-500 mt-1">
                  {selectedUser?.firstname} {selectedUser?.lastname}
                </span>
              </h2>
              
              {/* Close Icon Button */}
              <button 
                onClick={() => setModalOpen(false)}
                className="rounded-full p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
              >
                {/* Simple X icon SVG */}
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* 2. Content Body (Scrollable) */}
            <div className="max-h-[60vh] overflow-y-auto px-2 py-2">
              {accessLoading ? (
                <div className="flex h-40 items-center justify-center text-gray-500">
                  <FontAwesomeIcon icon={faSpinner} size="2x" spin />
                </div>
              ) : (
                <div className="space-y-1 p-2">
                  {screenOptions.length > 0 && (
                    <div className="mb-2 pb-2 border-b border-gray-100">
                      <div
                        onClick={handleSelectAll}
                        className="group flex cursor-pointer items-center rounded-lg p-3 transition-all duration-200 hover:bg-gray-50"
                      >
                        <div className="relative flex h-5 w-5 items-center justify-center">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            readOnly
                            className="peer h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-300 transition-all checked:border-black checked:bg-black group-hover:border-gray-400"
                          />
                          {/* Checkmark SVG */}
                          <svg
                            className="pointer-events-none absolute h-3.5 w-3.5 text-white opacity-0 transition-opacity peer-checked:opacity-100"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={3}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <label className="ml-3 cursor-pointer select-none font-inter text-sm font-bold text-gray-900">
                          {isAllSelected ? "Deselect All" : "Select All"}
                        </label>
                      </div>
                    </div>
                  )}

                  {/* --- 3. UPDATED LIST: Use screenOptions variable --- */}
                  {screenOptions.map((screen) => {
                    const isChecked = accesses.includes(screen.id);
                    return (
                      <div
                        key={screen.id}
                        onClick={() => toggleAccess(screen.id)}
                        className={`group flex cursor-pointer items-center rounded-lg p-3 transition-all duration-200 border border-transparent
                          ${isChecked ? "bg-gray-50 border-gray-200" : "hover:bg-gray-50"}`}
                      >
                        <div className="relative flex h-5 w-5 items-center justify-center">
                          <input
                            type="checkbox"
                            id={`screen-${screen.id}`}
                            checked={isChecked}
                            readOnly
                            className="peer h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-300 transition-all checked:border-black checked:bg-black group-hover:border-gray-400"
                          />
                          <svg
                            className="pointer-events-none absolute h-3.5 w-3.5 text-white opacity-0 transition-opacity peer-checked:opacity-100"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={3}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        
                        <label
                          htmlFor={`screen-${screen.id}`}
                          className="ml-3 cursor-pointer select-none font-inter text-sm font-medium text-gray-700 group-hover:text-gray-900"
                        >
                          {screen.field_code}
                        </label>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* 3. Footer (Fixed) */}
            <div className="flex justify-end gap-3 border-t border-gray-100 bg-gray-50/50 px-6 py-4">
              <button
                onClick={() => setModalOpen(false)}
                className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 font-inter text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={saveAccess}
                className="rounded-lg bg-black px-5 py-2.5 font-inter text-sm font-medium text-white shadow-lg shadow-gray-900/20 hover:bg-gray-800 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ListUser;